/** OpenStreetMap search URL from numeric coordinates. Not a map tile / SDK. */
export function openStreetMapUrl(latitude: number, longitude: number): string | null {
  if (!isValidMapCoordinate(latitude, longitude)) {
    return null;
  }
  const lat = latitude.toString();
  const lng = longitude.toString();
  return `https://www.openstreetmap.org/?mlat=${encodeURIComponent(lat)}&mlon=${encodeURIComponent(lng)}#map=17/${encodeURIComponent(lat)}/${encodeURIComponent(lng)}`;
}

/** Official OSM share embed. Compact bbox around the pin; no tile SDK. */
export function openStreetMapEmbedUrl(latitude: number, longitude: number): string | null {
  if (!isValidMapCoordinate(latitude, longitude)) {
    return null;
  }
  const span = 0.006;
  const south = clampLatitude(latitude - span);
  const north = clampLatitude(latitude + span);
  const west = clampLongitude(longitude - span);
  const east = clampLongitude(longitude + span);
  const bbox = [west, south, east, north].map((value) => encodeURIComponent(value.toString())).join(",");
  const marker = `${encodeURIComponent(latitude.toString())},${encodeURIComponent(longitude.toString())}`;
  return `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${marker}`;
}

export function isValidMapCoordinate(latitude: number, longitude: number): boolean {
  return (
    Number.isFinite(latitude) &&
    Number.isFinite(longitude) &&
    latitude >= -90 &&
    latitude <= 90 &&
    longitude >= -180 &&
    longitude <= 180
  );
}

function clampLatitude(value: number): number {
  return Math.min(90, Math.max(-90, value));
}

function clampLongitude(value: number): number {
  if (value < -180) return -180;
  if (value > 180) return 180;
  return value;
}
